/* LinenFriday: fabric by length (1 variant unit = 10 cm). PILOT, duplicate theme only.
 * Works together with snippets/lf-length.liquid (product form), snippets/lf-length-cart.liquid
 * (cart parts) and one guard line in theme.js ProductVariants._addToCart.
 * Old fractional scheme (dproduct / extra-quantity-select / _mainproduct / _relation-product)
 * is not touched here and is switched off in Liquid for tagged products only.
 */
(function () {
  'use strict';

  /* ---------- numbers ---------- */

  // "3,7" / "3.7" / "3.75" -> length in 10 cm units, rounded half-up to 0.1 m. null if not a number.
  function parseUnits(raw) {
    var value = String(raw == null ? '' : raw).trim().replace(/\s+/g, '').replace(',', '.');
    var match = /^(\d{1,4})(?:\.(\d*))?$/.exec(value);
    if (!match) return null;
    var decimals = match[2] || '';
    var units = parseInt(match[1], 10) * 10 + (decimals.length > 0 ? parseInt(decimals[0], 10) : 0);
    if (decimals.length > 1 && parseInt(decimals[1], 10) >= 5) units += 1;
    return units;
  }

  function parsePieces(raw) {
    var value = String(raw == null ? '' : raw).trim();
    return /^\d{1,3}$/.test(value) ? parseInt(value, 10) : null;
  }

  function lang() {
    return (document.documentElement.lang || 'en').slice(0, 2);
  }

  // 37 -> "3,7" (de/sl/it/...) or "3.7" (en). Never "5.0".
  function metres(units) {
    var whole = Math.floor(units / 10), tenth = units % 10;
    var sep = (1.5).toLocaleString(lang()).charAt(1) === ',' ? ',' : '.';
    return tenth ? whole + sep + tenth : String(whole);
  }

  // Shopify money format, e.g. "€{{amount_with_comma_separator}}"
  function formatMoney(cents, format) {
    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision).split('.');
      var whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    }
    format = String(format || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (all, key) {
      switch (key) {
        case 'amount': return delimit(cents, 2, ',', '.');
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- product form ---------- */

  function configFor(form) {
    if (form._lfConfig !== undefined) return form._lfConfig;
    var node = form.querySelector('[data-lf-length-config]');
    var config = null;
    if (node) { try { config = JSON.parse(node.textContent); } catch (e) { config = null; } }
    form._lfConfig = config;
    return config;
  }

  function variantIdFromForm(form) {
    var field = form.querySelector('[name="id"]');
    if (!field) return null;
    if (field.tagName === 'SELECT') {
      var selected = field.querySelector('option[selected]') || field.options[field.selectedIndex];
      return selected ? String(selected.value) : String(field.value);
    }
    return String(field.value);
  }

  function el(root, selector) { return root.querySelector(selector); }
  function rows(form) { return Array.prototype.slice.call(form.querySelectorAll('[data-lf-row]')); }

  // Theme quantity selector (and the hidden quantity=1 fallback) is not used in metre mode.
  function setNormalQuantity(form, enabled) {
    form.querySelectorAll('[name="quantity"]').forEach(function (input) {
      input.disabled = !enabled;
      if (enabled && input.type !== 'hidden') input.value = '1';
    });
    var item = el(form, '.product-form__info-item--quantity');
    if (item) item.style.display = enabled ? '' : 'none';
  }

  function setMessage(node, text) {
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  }

  // Validate one row: {ok, units, pieces, error}
  function shrinkOn(config, row) {
    if (!config.shrink || config.shrink <= 0) return false;
    var form = row.closest('form'), box = form && form.querySelector('[data-lf-shrink]');
    return Boolean(box && box.checked);
  }

  function evaluateRow(config, row) {
    var asked = parseUnits(el(row, '[data-lf-length-input]').value);
    var pieces = parsePieces(el(row, '[data-lf-pieces-input]').value);
    var t = config.t;
    if (asked === null || asked === 0 || pieces === null || pieces < 1) return { ok: false, error: t.errFormat };
    if (asked < config.minUnits) return { ok: false, units: asked, asked: asked, pieces: pieces, error: t.errMin };
    if (asked > config.maxUnitsPerPiece) return { ok: false, units: asked, asked: asked, pieces: pieces, error: t.errFormat };
    // Above the threshold (20 m) only whole metres: rolls are cut in whole metres.
    if (asked > config.wholeMetresFrom && asked % 10 !== 0) return { ok: false, units: asked, asked: asked, pieces: pieces, error: t.errMax };
    if (pieces > config.maxPieces) return { ok: false, units: asked, asked: asked, pieces: pieces, error: t.errFormat };
    var units = asked;
    // "Length after washing": add the fabric's shrinkage, rounded UP to 10 cm (above 20 m: to a whole metre).
    if (shrinkOn(config, row)) {
      units = Math.ceil(asked * 100 / (100 - config.shrink) - 1e-9);
      if (units > config.wholeMetresFrom) units = Math.ceil(units / 10) * 10;
      if (units > config.maxUnitsPerPiece) return { ok: false, units: units, asked: asked, pieces: pieces, error: t.errFormat };
    }
    return { ok: true, units: units, asked: asked, pieces: pieces };
  }

  // Validate all rows together (stock is checked on the sum): {ok, lines:[{units,pieces}], total, error, badRow}
  function evaluate(form) {
    var config = configFor(form), variant = form._lfState.variant;
    var lines = [], totalUnits = 0, list = rows(form);
    for (var i = 0; i < list.length; i++) {
      var r = evaluateRow(config, list[i]);
      if (!r.ok) return { ok: false, error: r.error, badRow: list[i] };
      lines.push(r);
      totalUnits += r.units * r.pieces;
    }
    if (variant.deny && totalUnits > variant.stock) {
      return { ok: false, error: config.t.errStock + ' ' + metres(Math.max(0, variant.stock)) + ' m', badRow: list[list.length - 1] };
    }
    return { ok: true, lines: lines, totalUnits: totalUnits };
  }

  function render(form, normalize) {
    var state = form._lfState;
    var wrapper = el(form, '[data-lf-length-controls]');
    var active = Boolean(state.variant);
    wrapper.hidden = !active;
    setNormalQuantity(form, !active);
    if (!active) return;

    var config = configFor(form), variant = state.variant;
    var note = '';
    rows(form).forEach(function (row, index) {
      var input = el(row, '[data-lf-length-input]');
      var r = evaluateRow(config, row);
      // Show the corrected value (1.25 -> 1.3, 1.23 -> 1.2) once the customer leaves the field.
      if (normalize && r.asked) {
        var shown = metres(r.asked);
        if (input.value.trim() !== shown) {
          if (/[.,]\d{2,}/.test(input.value)) note = config.t.rounded + ' ' + shown + ' m';
          input.value = shown;
        }
      }
      input.setAttribute('aria-invalid', r.ok ? 'false' : 'true');
      el(row, '[data-lf-remove]').hidden = index === 0;
    });
    var addButton = el(form, '[data-lf-add]');
    if (addButton) addButton.hidden = rows(form).length >= config.maxRows;

    var result = evaluate(form);
    setMessage(el(form, '[data-lf-note]'), note);
    setMessage(el(form, '[data-lf-error]'), result.ok ? '' : result.error);
    el(form, '[data-lf-total]').textContent = result.ok ? formatMoney(variant.price * result.totalUnits, config.moneyFormat) : '—';
    var shrinkNote = el(form, '[data-lf-shrink-note]');
    if (shrinkNote) {
      var on = result.ok && rows(form).length && shrinkOn(config, rows(form)[0]);
      var list = on ? result.lines.map(function (line) { return metres(line.units) + ' m' + (line.pieces > 1 ? ' × ' + line.pieces : ''); }).join(', ') : '';
      setMessage(shrinkNote, on ? (config.t.shrinkNote || '').replace('{list}', list).replace('{s}', config.shrink) : '');
    }
  }

  // Price per metre + stock in metres for the metrage variant. Runs after the theme wrote its own values.
  function renderPriceAndStock(form) {
    var state = form._lfState, config = configFor(form);
    if (!state.variant) return;
    var variant = state.variant, suffix = config.hasMetreLabel ? '' : ' / m';
    var list = el(form, '.price-list');
    if (list) {
      var html = '';
      if (variant.compare > variant.price) {
        html += '<span class="price price--highlight">' + formatMoney(variant.price * 10, config.moneyFormat) + suffix + '</span>';
        html += '<span class="price price--compare">' + formatMoney(variant.compare * 10, config.moneyFormat) + suffix + '</span>';
      } else {
        html += '<span class="price">' + formatMoney(variant.price * 10, config.moneyFormat) + suffix + '</span>';
      }
      list.innerHTML = html;
      list.style.display = '';
    }
    var stock = el(form, '.product-form__inventory');
    if (stock && variant.deny && variant.stock > 0) stock.textContent = config.t.stock + ' ' + metres(variant.stock) + ' m';
  }

  // Theme skips its own price redraw when two variants share a price, so after leaving the
  // metrage variant we redraw the plain price ourselves.
  function restoreThemePrice(form, themeVariant) {
    var list = el(form, '.price-list'), config = configFor(form);
    if (!list || !themeVariant) return;
    var html = '';
    if (themeVariant.compare_at_price > themeVariant.price) {
      html += '<span class="price price--highlight">' + formatMoney(themeVariant.price, config.moneyFormat) + '</span>';
      html += '<span class="price price--compare">' + formatMoney(themeVariant.compare_at_price, config.moneyFormat) + '</span>';
    } else {
      html += '<span class="price">' + formatMoney(themeVariant.price, config.moneyFormat) + '</span>';
    }
    list.innerHTML = html;
  }

  function resetRows(form) {
    rows(form).forEach(function (row, index) { if (index > 0) row.parentNode.removeChild(row); });
    var first = rows(form)[0];
    el(first, '[data-lf-length-input]').value = '1';
    el(first, '[data-lf-pieces-input]').value = '1';
  }

  function addRow(form) {
    var config = configFor(form), list = rows(form);
    if (list.length >= config.maxRows) return;
    var row = list[0].cloneNode(true);
    el(row, '[data-lf-length-input]').value = '1';
    el(row, '[data-lf-pieces-input]').value = '1';
    list[list.length - 1].parentNode.appendChild(row);
    render(form, false);
    var input = el(row, '[data-lf-length-input]');
    if (input.focus) { input.focus(); if (input.select) input.select(); }
  }

  function setVariant(form, variantId, reset, themeVariant) {
    var config = configFor(form);
    var state = form._lfState;
    var wasActive = Boolean(state.variant);
    state.variant = variantId && config.variants[String(variantId)] ? config.variants[String(variantId)] : null;
    state.variantId = state.variant ? Number(variantId) : null;
    if (wasActive && !state.variant) restoreThemePrice(form, themeVariant);
    if (reset && state.variant) resetRows(form);
    render(form, false);
    renderPriceAndStock(form);
  }

  // Other cart properties of the form (e.g. Overlock), without our own fields.
  function baseProperties(form) {
    var props = {};
    Array.prototype.forEach.call(form.elements, function (input) {
      var m = /^properties\[(.+)\]$/.exec(input.name || '');
      if (!m || input.disabled) return;
      if (input.type === 'checkbox' && !input.checked) return;
      props[m[1]] = input.value;
    });
    return props;
  }

  function newId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (content) {
        if (!response.ok) { var e = new Error(content && content.description ? content.description : 'Cart error'); e.shopify = true; throw e; }
        return content;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js?lf=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  // Removes cart lines from this request whose quantity is not what we asked for.
  function removeIncomplete(items) {
    var wanted = {};
    items.forEach(function (item) { wanted[item.properties._lf_id] = item.quantity; });
    return getCart().then(function (cart) {
      var bad = (cart.items || []).filter(function (line) {
        var id = line.properties && line.properties._lf_id;
        return id && wanted[id] !== undefined && line.quantity !== wanted[id];
      });
      return bad.reduce(function (chain, line) {
        return chain.then(function () {
          return postJSON(((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js', { id: line.key, quantity: 0 }).catch(function () {});
        });
      }, Promise.resolve()).then(function () { return bad.length; });
    });
  }

  // Adds every row as its own cart line in ONE request, then lets the theme refresh/open the mini cart.
  // Stock is checked against what is already in the cart, so the customer gets a clear message.
  function addToCart(form, result) {
    if (form._lfBusy) return;
    var config = configFor(form), variant = form._lfState.variant, variantId = form._lfState.variantId;
    // Only ever send the metrage variant (never the sample id that the theme select may still hold).
    if (!variant || !variantId || !config.variants[String(variantId)]) return;
    var pk = (el(form, '[data-lf-pk]') || {}).value || config.propPieces;
    var base = baseProperties(form);
    var items = result.lines.map(function (line) {
      var props = {};
      Object.keys(base).forEach(function (k) { props[k] = base[k]; });
      props[config.propLength] = metres(line.units) + ' m';
      props[config.propPieces] = String(line.pieces);
      props._lf_units = String(line.units);
      if (line.asked && line.asked !== line.units) props._lf_after_shrink = metres(line.asked) + ' m (+' + config.shrink + '%)';
      props._lf_pk = pk;
      props._lf_id = newId();
      return { id: variantId, quantity: line.units * line.pieces, properties: props };
    });
    var button = el(form, '[data-action="add-to-cart"]');
    var done = function () {
      form._lfBusy = false;
      if (button) button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    };
    form._lfBusy = true;
    if (button) button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var inCart = 0;
    var stockMessage = function () {
      return config.t.inCart.replace('{in}', metres(inCart)).replace('{left}', metres(Math.max(0, variant.stock - inCart)));
    };
    getCart()
      .then(function (cart) {
        inCart = (cart.items || []).reduce(function (sum, item) { return item.variant_id === variantId ? sum + item.quantity : sum; }, 0);
        if (variant.deny && inCart + result.totalUnits > variant.stock) throw new Error(stockMessage());
        return postJSON(((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js', { items: items }).catch(function (error) {
          // Shopify may add a piece only partly ("Only 10 items were added"): the line would then say
          // 1,4 m x 2 but hold 1 m. Remove such incomplete lines and explain in our own words.
          return removeIncomplete(items).then(getCart).then(function (fresh) {
            inCart = (fresh.items || []).reduce(function (sum, item) { return item.variant_id === variantId ? sum + item.quantity : sum; }, 0);
            if (variant.deny && inCart + result.totalUnits > variant.stock) throw new Error(stockMessage());
            throw new Error(config.t.stockChanged || error.message); // shop has less than the page shows
          });
        });
      })
      .then(function () {
        done();
        var pieces = result.lines.reduce(function (sum, line) { return sum + line.pieces; }, 0);
        if (window.theme && window.theme.cartType === 'page') { window.location.href = '/cart'; return; }
        if (form.closest('.modal')) document.dispatchEvent(new CustomEvent('modal:close'));
        form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: null, quantity: pieces, button: button } }));
        if (window.console) console.info('[LF length] added', items.length, 'line(s)');
        setTimeout(refreshCart, 800); // safety net: badge/mini cart always catch up
      })
      .catch(function (error) {
        done();
        setMessage(el(form, '[data-lf-error]'), error.message);
        if (window.console) console.warn('[LF length] add to cart:', error.message);
        refreshCart(); // the cart may still have changed: always show the real state
      });
  }

  function initForm(form) {
    if (form._lfState || !configFor(form)) return;
    var wrapper = el(form, '[data-lf-length-controls]');
    if (!wrapper) return;
    form._lfState = { variant: null };

    // Keep theme handlers (QuantityPicker, cart quantity) away from our fields.
    ['keyup', 'focusout', 'change'].forEach(function (type) {
      wrapper.addEventListener(type, function (event) { event.stopPropagation(); });
    });
    // Delegated, so rows added later work too.
    wrapper.addEventListener('input', function (event) {
      if (event.target.matches('[data-lf-length-input], [data-lf-pieces-input]')) render(form, false);
    });
    wrapper.addEventListener('change', function (event) {
      if (event.target.matches('[data-lf-shrink]')) render(form, false);
    });
    wrapper.addEventListener('focusout', function (event) {
      if (event.target.matches('[data-lf-length-input], [data-lf-pieces-input]')) render(form, true);
    }, true);
    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); render(form, true); }
    });

    wrapper.addEventListener('click', function (event) {
      var config = configFor(form);
      if (event.target.closest('[data-lf-add]')) { event.preventDefault(); addRow(form); return; }
      var remove = event.target.closest('[data-lf-remove]');
      if (remove) {
        event.preventDefault();
        var row = remove.closest('[data-lf-row]');
        if (rows(form).length > 1) row.parentNode.removeChild(row);
        render(form, false);
        return;
      }
      var step = event.target.closest('[data-lf-step]');
      var pstep = event.target.closest('[data-lf-pstep]');
      if (!step && !pstep) return;
      event.preventDefault();
      event.stopPropagation();
      var row = (step || pstep).closest('[data-lf-row]');
      if (step) {
        var lengthInput = el(row, '[data-lf-length-input]');
        var units = parseUnits(lengthInput.value) || config.minUnits;
        var dir = Number(step.getAttribute('data-lf-step'));
        var next;
        if (dir > 0 && units >= config.wholeMetresFrom) next = Math.floor(units / 10) * 10 + 10;      // 20 -> 21 -> 22
        else if (dir < 0 && units > config.wholeMetresFrom) next = Math.max(config.wholeMetresFrom, Math.ceil(units / 10) * 10 - 10);
        else next = units + dir;                                                                         // 0.1 m below 20 m
        lengthInput.value = metres(Math.min(config.maxUnitsPerPiece, Math.max(config.minUnits, next)));
      } else {
        var piecesInput = el(row, '[data-lf-pieces-input]');
        var pieces = parsePieces(piecesInput.value) || 1;
        piecesInput.value = String(Math.min(config.maxPieces, Math.max(1, pieces + Number(pstep.getAttribute('data-lf-pstep')))));
      }
      render(form, true);
    });

    // Native submit must never go through in metre mode.
    form.addEventListener('submit', function (event) {
      if (!api.beforeAdd(form)) { event.preventDefault(); event.stopPropagation(); }
    });

    setVariant(form, variantIdFromForm(form), true);
    form.setAttribute('data-lf-ready', '');
  }

  function scan(root) {
    (root || document).querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      initForm(form);
      initSample(form);
    });
  }

  /* ---------- samples (all fabric products) ----------
   * When the "FABRIC SAMPLE" variant is selected: no Overlock, no quantity (always 1). */

  // Fallback only (no lf config): words in all 4 languages. Normal path = config.samples ids (v5.4).
  function isSampleTitle(text) { return /sample|vzor|muster|probe|campion/i.test(String(text || '')); }

  function sampleIds(form) {
    var config = configFor(form);
    return config && config.samples ? config.samples : null;
  }

  function sampleSelected(form, themeVariant) {
    var ids = sampleIds(form);
    if (ids) {
      var id = themeVariant ? themeVariant.id : variantIdFromForm(form);
      return id != null && ids.indexOf(String(id)) !== -1;
    }
    if (themeVariant) return isSampleTitle(themeVariant.title || (themeVariant.options || []).join(' '));
    var field = form.querySelector('[name="id"]');
    if (!field || field.tagName !== 'SELECT') return false;
    var option = field.querySelector('option[selected]') || field.options[field.selectedIndex];
    return option ? isSampleTitle(option.textContent) : false;
  }

  function applySample(form, themeVariant) {
    var overlock = form.querySelector('.line-item-property__field');
    if (!overlock) return; // only fabric products have the Overlock field
    var sample = sampleSelected(form, themeVariant);
    overlock.style.display = sample ? 'none' : '';
    overlock.querySelectorAll('input').forEach(function (input) {
      input.disabled = sample;
      if (sample && input.type === 'checkbox') input.checked = false;
    });
    if (form._lfState && form._lfState.variant) return; // metre mode handles its own quantity
    var quantityItem = el(form, '.product-form__info-item--quantity');
    form.querySelectorAll('[name="quantity"]').forEach(function (input) { if (sample) input.value = '1'; });
    if (quantityItem) quantityItem.style.display = sample ? 'none' : '';
  }

  function initSample(form) {
    if (form._lfSample || !form.querySelector('.line-item-property__field')) return;
    form._lfSample = true;
    applySample(form, null);
  }

  // Theme fires this BEFORE it updates the hidden id select, so the variant comes from event.detail.
  document.addEventListener('variant:changed', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    var variant = event.detail && event.detail.variant;
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (!form._lfState) initForm(form);
      if (form._lfState) setVariant(form, variant ? variant.id : null, true, variant);
      initSample(form);
      if (form._lfSample) applySample(form, variant);
    });
  });

  /* ---------- cart (main cart + mini cart) ---------- */

  function injectCartStyles() {
    if (document.getElementById('lf-length-cart-css')) return;
    var style = document.createElement('style');
    style.id = 'lf-length-cart-css';
    style.textContent = '.lf-cart-qty__value{-webkit-appearance:none;appearance:none;padding:0 5px;min-width:32px;text-align:center;border:none;background:transparent;height:100%}' +
      '.lf-cart-qty__value:focus{outline:none}.lf-cart-qty[aria-busy="true"]{opacity:.5;pointer-events:none}';
    document.head.appendChild(style);
  }

  function changeLine(box, pieces) {
    var units = parseInt(box.getAttribute('data-units'), 10);
    var input = box.querySelector('.lf-cart-qty__value');
    var current = parseInt(input.getAttribute('data-current-value'), 10);
    var max = parseInt(box.getAttribute('data-max'), 10) || 0;
    if (pieces === null || !units) { input.value = current; return; }
    if (max > 0 && pieces > max) pieces = max;
    if (pieces === current) { input.value = current; return; }

    var props = {};
    try { props = JSON.parse(box.getAttribute('data-props')) || {}; } catch (e) { props = {}; }
    var pk = props._lf_pk || 'Pieces';
    if (pieces > 0) props[pk] = String(pieces);

    var body = { line: parseInt(box.getAttribute('data-line'), 10), quantity: pieces * units };
    if (pieces > 0) body.properties = props;

    box.setAttribute('aria-busy', 'true');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (content) {
        if (!response.ok) throw new Error(content && content.description ? content.description : 'Cart error');
      });
    }).catch(function (error) {
      input.value = current;
      window.alert(error.message);
    }).then(function () {
      box.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-lf-cart-step]');
    if (!button) return;
    event.preventDefault();
    var box = button.closest('[data-lf-cart]');
    var input = box.querySelector('.lf-cart-qty__value');
    var current = parseInt(input.getAttribute('data-current-value'), 10) || 1;
    var next = current + Number(button.getAttribute('data-lf-cart-step'));
    if (next < 1) return; // removing is done with the theme "Remove" link
    changeLine(box, next);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('lf-cart-qty__value')) return;
    changeLine(event.target.closest('[data-lf-cart]'), parsePieces(event.target.value));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.classList || !event.target.classList.contains('lf-cart-qty__value')) return;
    event.preventDefault(); // inside the cart form Enter would submit to checkout
    event.target.blur();
  });

  // Samples are sent free, one per fabric: a sample line with quantity > 1 is set back to 1.
  var fixingSample = false, sampleAttempts = 0;
  function fixSampleQuantities() {
    if (fixingSample || sampleAttempts >= 3) return;
    var node = document.querySelector('[data-lf-sample-line]:not([data-qty="1"])');
    if (!node) return;
    fixingSample = true;
    sampleAttempts++;
    fetch(((window.routes && window.routes.cartChangeUrl) || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: parseInt(node.getAttribute('data-lf-sample-line'), 10), quantity: 1 })
    }).catch(function () {}).then(function () {
      fixingSample = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
    });
  }

  /* ---------- header cart badge (v5.5) ----------
   * Liquid renders pieces on page load, but the theme rewrites .header__cart-count with
   * cart.item_count (10 cm units) after AJAX changes. Recount from /cart.js and put pieces back. */

  var badgeTimer = null, badgeBusy = false, badgeValue = null;
  function piecesCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      var u = parseInt(item.properties && item.properties._lf_units, 10);
      return sum + (u > 0 ? Math.floor(item.quantity / u) : item.quantity);
    }, 0);
  }
  function fixBadge() {
    if (badgeBusy) return;
    var nodes = document.querySelectorAll('.header__cart-count');
    if (!nodes.length) return;
    badgeBusy = true;
    getCart().then(function (cart) {
      badgeValue = String(piecesCount(cart));
      nodes = document.querySelectorAll('.header__cart-count');
      Array.prototype.forEach.call(nodes, function (n) { if (n.textContent.trim() !== badgeValue) n.textContent = badgeValue; });
    }).then(function () { badgeBusy = false; }, function () { badgeBusy = false; });
  }
  function watchBadge() {
    var nodes = document.querySelectorAll('.header__cart-count');
    Array.prototype.forEach.call(nodes, function (n) {
      if (n._lfWatched) return;
      n._lfWatched = true;
      new MutationObserver(function () {
        if (badgeValue !== null && n.textContent.trim() === badgeValue) return; // our own write
        clearTimeout(badgeTimer);
        badgeTimer = setTimeout(fixBadge, 150);
      }).observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- public API (used by the theme.js guard) ---------- */

  var api = {
    version: '2026-10-18-v5.5',
    parseUnits: parseUnits,
    metres: metres,
    formatMoney: formatMoney,
    // true = let the theme add to cart (not metre mode). In metre mode we add ourselves and return false.
    beforeAdd: function (form) {
      if (!configFor(form)) return true;
      if (!form._lfState) initForm(form);
      if (!form._lfState || !form._lfState.variant) return true;
      render(form, true);
      var result = evaluate(form);
      if (!result.ok) {
        var input = result.badRow && el(result.badRow, '[data-lf-length-input]');
        if (input && input.focus) input.focus();
        return false;
      }
      addToCart(form, result);
      return false;
    }
  };
  window.LFLength = api;

  function boot() {
    injectCartStyles();
    watchBadge();
    scan(document);
    // Quick view modals and theme editor reloads insert new product forms.
    fixSampleQuantities();
    var sampleTimer = null;
    new MutationObserver(function (records) {
      clearTimeout(sampleTimer);
      sampleTimer = setTimeout(fixSampleQuantities, 300);
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType === 1 && (node.matches('[data-lf-length-config], form') || node.querySelector('[data-lf-length-config]'))) {
            scan(document);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
